export default __webpack_public_path__ + "static/media/nft_icon1.eef0de6f.png";